<div
  class="card-task p-3 position-relative rounded-4 shadow-sm"
  [ngClass]="{
    'status-exception': selectedTaskStatus() === TaskStatusEnum.COMPLETED_WITH_EXCEPTION,
    'status-completed': selectedTaskStatus() === TaskStatusEnum.COMPLETED,
    'status-skip': selectedTaskStatus() === TaskStatusEnum.SKIP,
    'card-task-selected': isSelected(),
    'card-task-freeze': scheduleTaskItem().isLotOnHold
  }"
>
  <div class="d-flex align-items-center mb-2">
    <div class="d-flex flex-column flex-sm-row align-items-sm-center gap-sm-3 gap-1">
      <h3 class="fw-semibold mb-0">{{ scheduleTaskItem().taskName }}</h3>
      @if (scheduleTaskItem().predecessorName) {
        <div class="d-flex align-items-center gap-2">
          <i class="bi bi-arrow-right d-flex align-items-center"></i>
          <span class="lh-sm"> {{ scheduleTaskItem().predecessorName }} </span>
        </div>
      }
    </div>
    <span class="ms-auto">
      <span class="d-flex align-items-center gap-2">
        @if (scheduleTaskItem().isLotOnHold && !scheduleTaskItem().isOnHold) {
          <span class="badge badge-freeze fw-500"> <i class="bi bi-snow me-1"></i>Freeze </span>
        }
        @if (scheduleTaskItem().isOnHold) {
          <span class="badge badge-onhold fw-500"> <i class="bi bi-pause-circle me-1"></i>On Hold </span>
        }
        @if (scheduleTaskItem().status) {
          <span class="badge bg-success-subtle fw-500 text-bg-light">{{ scheduleTaskItem().status }}</span>
        }
      </span>
    </span>
  </div>

  <div class="mb-2 d-flex align-items-sm-center gap-sm-4 flex-sm-row flex-column">
    <span
      ><span class="fw-500 text-black-50 me-2">Lot:</span>
      <span class="fw-500">{{ scheduleTaskItem().lotNo }}</span></span
    >
    <span
      ><span class="fw-500 text-black-50 me-2">Stage Name:</span>
      <span class="fw-500">{{ scheduleTaskItem().stageName }}</span></span
    >
  </div>
  <div class="row flex-wrap gap-2 align-items-sm-end flex-sm-row flex-column">
    <div class="col-auto">
      <i class="bi bi-calendar3 me-2"></i>
      <span class="fw-500 text-black-50 me-2">Revised Date:</span>
      <span class="fs-16 fw-500">
        {{ scheduleTaskItem().revisedStartDate | date: 'MMM d, y' }} -
        {{ scheduleTaskItem().revisedEndDate | date: 'MMM d, y' }}
      </span>
    </div>
    <div class="col-auto">
      <i class="bi bi-clock me-2"></i>
      <span class="fw-500 text-black-50 me-2">Duration:</span>
      <span class="fs-16 fw-500">{{ scheduleTaskItem().duration }}</span>
    </div>
  </div>
</div>
